import { safeGet } from "./api";

// Klaviyo onsite script: shows the popup forms built in Klaviyo and sends browser events for flows.
// Calls are queued in _klOnsite until the script has loaded.
const queue = (...args) => {
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(args);
};

let loaded = false;
export const loadKlaviyo = async () => {
  if (loaded) return;
  loaded = true;
  const cfg = await safeGet("/klaviyo/config", null);
  const key = cfg?.public_key;
  if (!key) return;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://static.klaviyo.com/onsite/js/${key}/klaviyo.js?company_id=${key}`;
  document.head.appendChild(s);
};

export const klaviyoIdentify = (email) => queue("identify", { email });

export const klaviyoViewedProduct = (p) => queue("track", "Viewed Product", {
  ProductName: p.name,
  ProductID: p.shopifyId,
  URL: window.location.href,
  ImageURL: p.gallery?.[0] || p.image,
  Price: Number(p.price),
});

export const klaviyoAddedToCart = (p, price, cart) => {
  const items = cart?.lines?.nodes ?? [];
  queue("track", "Added to Cart", {
    $value: Number(cart?.cost?.totalAmount?.amount ?? price),
    AddedItemProductName: p.name,
    AddedItemProductID: p.shopifyId,
    AddedItemPrice: Number(price),
    AddedItemImageURL: p.gallery?.[0] || p.image,
    AddedItemURL: `${window.location.origin}/products/${p.role}`,
    ItemNames: items.map((l) => l?.merchandise?.product?.title).filter(Boolean),
    CheckoutURL: cart?.checkoutUrl,
  });
};
